<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="alertaAcceso.estatus"
    persistent
    max-width="400"
  >
    <v-card>
      <v-card-title class="text-h5">
        <v-spacer></v-spacer>
        ¡Sin acceso!
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>

        <v-progress-linear
          v-model="value"
          :active="show"
          :indeterminate="query"
          :query="true"
          color="red"
        ></v-progress-linear>

        <h3 class="text-body-1 font-weight-light mb-2">
          <br/>
          <strong>Lo sentimos, pero no acreditaste tu nivel anterior, comunícate con tu sucursal para una reubicación de nivel</strong>
          <br/>
        </h3>

      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          dark
          color="error"
          @click="$emit('click')"
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'

	export default {
		props:[
			'alertaAcceso'
	  ],

		data () {
      return {
        parametros:{
          dialogError: false,
          mensaje: '',
          color: ''
        },
        
        value: 0,
        query: false,
        show: true,
        interval: 0,
        sinAcceso:false,
      }
    },

    async created ( ){
      this.iniciarContador()
    },

    methods:{
    	...mapActions( 'login', ['salirLogin' ]),

      iniciarContador ( ){
        this.query = true
        this.show  = true
        this.value = 0

        setTimeout(() => {
          this.query = false
          this.interval = setInterval(() => {
            if (this.value === 100) {
              clearInterval(this.interval)
              this.salirLogin()
              return setTimeout(this.queryAndIndeterminate, 2000)
            }
            this.value += 10
          }, 1000)
        }, 1000)
      },

     
      validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

      
    }
  }
</script>

